import React from 'react';
import forbiddenimg from '../../../assets/images/forbiddenimg.svg';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Forbidden: React.FC = () => {
  return (
    <>
      <div className="error_page">
        <div className="common_card">
          <div className="page_not_found">
            <div className="page_not_found_img">
              <img src={forbiddenimg} alt="forbiddenimg" />
            </div>
            {/* <div className="page_not_found_btn">
              <Link to={"/home"}><Button variant="primary">Bring To Home</Button></Link>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Forbidden;